import SessionActions from '../actions/SessionActions'

class LogoutUtilClass {
  logout() {
    SessionActions.deleteSession();
  }
}
const LogoutUtil = new LogoutUtilClass()
export default LogoutUtil